import { apiSlice } from "../../app/api/apiSlice";

export const subscriptionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptions: builder.query({
      query: () => "/subscriptions",
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "Subscription", id: _id })),
              { type: "Subscription", id: "LIST" },
            ]
          : [{ type: "Subscription", id: "LIST" }],
    }),
    updateSubscription: builder.mutation({
      query: ({ tenantId, ...data }) => ({
        url: `/subscriptions/${tenantId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { tenantId }) => [
        { type: "Subscription", id: tenantId },
        { type: "Subscription", id: "LIST" },
        { type: "Tenant", id: tenantId },
      ],
    }),
    getTenantBookings: builder.query({
      query: (tenantId) => `/subscriptions/${tenantId}/bookings`,
      providesTags: (result, error, tenantId) => [
        { type: "TenantBooking", id: tenantId },
      ],
    }),
    createTenantBooking: builder.mutation({
      query: ({ tenantId, ...data }) => ({
        url: `/subscriptions/${tenantId}/bookings`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { tenantId }) => [
        { type: "TenantBooking", id: tenantId },
        { type: "Subscription", id: tenantId },
        { type: "Subscription", id: "LIST" },
      ],
    }),
    getSepaExportData: builder.mutation({
      query: (data) => ({
        url: "/subscriptions/sepa-export",
        method: "POST",
        body: data,
      }),
    }),
    markBookingsCollected: builder.mutation({
      query: (data) => ({
        url: "/subscriptions/mark-collected",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        { type: "TenantBooking" },
        { type: "Subscription", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetSubscriptionsQuery,
  useUpdateSubscriptionMutation,
  useGetTenantBookingsQuery,
  useCreateTenantBookingMutation,
  useGetSepaExportDataMutation,
  useMarkBookingsCollectedMutation,
} = subscriptionsApiSlice;
